const SEO = [
  {
    page: "home",
    description:
      "Personal webpage of Manuel J. Gomez, Assistant Professor at the University of Murcia. Researcher in Game-Based Assessment, Learning Analytics, and Artificial Intelligence.",
    keywords: [
      "Manuel J. Gomez",
      "University of Murcia",
      "Assistant Professor",
      "PhD Computer Science",
      "Game-Based Assessment",
      "Learning Analytics",
      "Artificial Intelligence",
      "LLMs",
    ],
  },
  {
    page: "research",
    description:
      "Research by Manuel J. Gomez in Learning Analytics, Game-Based Assessment, Artificial Intelligence, and Large Language Models, with collaborations at MIT and the University of Murcia.",
    keywords: [
      "Research",
      "Learning Analytics",
      "Game-Based Assessment",
      "Artificial Intelligence",
      "Large Language Models",
      "MIT",
      "CyberDataLab",
    ],
  },
  {
    page: "teaching",
    description:
      "Teaching experience of Manuel J. Gomez at the University of Murcia, including undergraduate and graduate courses in Business Intelligence, Big Data, and supervision of thesis projects.",
    keywords: [
      "Teaching",
      "Business Intelligence",
      "Big Data",
      "University of Murcia",
      "Thesis supervision",
    ],
  },
  {
    page: "publication",
    description:
      "List of scientific publications by Manuel J. Gomez on topics including Serious Games, Learning Analytics, Artificial Intelligence, and Educational Technology.",
    keywords: [
      "Publications",
      "Game-Based Assessment",
      "Serious Games",
      "Learning Analytics",
      "AI in Education",
      "Research Papers",
    ],
  },
  {
    page: "projects",
    description:
      "Research projects involving Manuel J. Gomez, such as REASSESS, EU-GUARDIAN, and LAGA, focused on interoperability, AI in education, and cybersecurity.",
    keywords: [
      "Projects",
      "REASSESS",
      "EU-GUARDIAN",
      "LAGA",
      "Cybersecurity",
      "Interoperability",
      "AI Research",
    ],
  },
  {
    page: "braveroom",
    description:
      "BraveRoom is a platform by Manuel J. Gomez for designing, facilitating, and reviewing realistic scenario-based practice.",
    keywords: [
      "BraveRoom",
      "Scenario-Based Learning",
      "Simulation Training",
      "AI Simulation",
      "Experiential Learning",
      "Learning Analytics",
      "Next.js",
      "Educational Technology",
    ],
  },
  {
    page: "ludix",
    description:
      "Ludix is open research software by Manuel J. Gomez for reproducible, game-agnostic learning analytics across serious games.",
    keywords: [
      "Ludix",
      "Serious Games",
      "Learning Analytics",
      "Process Mining",
      "Transition Network Analysis",
      "Explainable AI",
      "Educational Data Mining",
      "Open Research Software",
    ],
  },
  {
    page: "gallery",
    description:
      "A gallery of professional and research-related photos of Manuel J. Gomez, including conferences, interviews, and collaborations with MIT and the University of Murcia.",
    keywords: [
      "Gallery",
      "MIT",
      "University of Murcia",
      "Research",
      "Events",
      "Photos",
    ],
  },
  {
    page: "phd",
    description:
      "Ph.D. thesis by Manuel J. Gomez titled 'Towards Interoperability and Novel Methodological Approaches for Scalable Game-Based Assessment'.",
    keywords: [
      "PhD Thesis",
      "Game-Based Assessment",
      "Interoperability",
      "Ontology",
      "Explainable AI",
      "Serious Games",
    ],
  },
  {
    page: "contact",
    description:
      "Contact information for Dr. Manuel J. Gomez, including email, social media links, and office location at the University of Murcia.",
    keywords: [
      "Contact",
      "Email",
      "LinkedIn",
      "University of Murcia",
      "Manuel Gomez",
    ],
  },
];

const SEO_ES = {
  home: {
    description:
      "Página personal de Manuel J. Gomez, Profesor Ayudante Doctor en la Universidad de Murcia. Investigador en evaluación basada en juegos, analítica del aprendizaje e inteligencia artificial.",
    keywords: [
      "Manuel J. Gomez",
      "Universidad de Murcia",
      "Profesor Ayudante Doctor",
      "Doctorado en Informática",
      "Evaluación basada en juegos",
      "Analítica del aprendizaje",
      "Inteligencia artificial",
      "LLM",
    ],
  },
  research: {
    description:
      "Investigación de Manuel J. Gomez en analítica del aprendizaje, evaluación basada en juegos, inteligencia artificial y grandes modelos de lenguaje, con colaboraciones en el MIT y la Universidad de Murcia.",
    keywords: [
      "Investigación",
      "Analítica del aprendizaje",
      "Evaluación basada en juegos",
      "Inteligencia artificial",
      "Grandes modelos de lenguaje",
      "MIT",
      "CyberDataLab",
    ],
  },
  teaching: {
    description:
      "Experiencia docente de Manuel J. Gomez en la Universidad de Murcia, con asignaturas de grado y máster sobre inteligencia de negocio y Big Data, y dirección de trabajos fin de estudios.",
    keywords: [
      "Docencia",
      "Inteligencia de negocio",
      "Big Data",
      "Universidad de Murcia",
      "Dirección de TFG y TFM",
    ],
  },
  publication: {
    description:
      "Lista de publicaciones científicas de Manuel J. Gomez sobre juegos serios, analítica del aprendizaje, inteligencia artificial y tecnología educativa.",
    keywords: [
      "Publicaciones",
      "Evaluación basada en juegos",
      "Juegos serios",
      "Analítica del aprendizaje",
      "IA en educación",
      "Artículos de investigación",
    ],
  },
  projects: {
    description:
      "Proyectos de investigación en los que participa Manuel J. Gomez, como REASSESS, EU-GUARDIAN y LAGA, centrados en interoperabilidad, IA en educación y ciberseguridad.",
    keywords: [
      "Proyectos",
      "REASSESS",
      "EU-GUARDIAN",
      "LAGA",
      "Ciberseguridad",
      "Interoperabilidad",
      "Investigación en IA",
    ],
  },
  braveroom: {
    description:
      "BraveRoom es una plataforma de Manuel J. Gomez para diseñar, facilitar y revisar prácticas realistas basadas en escenarios.",
    keywords: [
      "BraveRoom",
      "Aprendizaje basado en escenarios",
      "Formación con simulación",
      "Simulación con IA",
      "Aprendizaje experiencial",
      "Analítica del aprendizaje",
      "Next.js",
      "Tecnología educativa",
    ],
  },
  ludix: {
    description:
      "Ludix es un software de investigación abierto de Manuel J. Gomez para una analítica del aprendizaje reproducible e independiente del juego en juegos serios.",
    keywords: [
      "Ludix",
      "Juegos serios",
      "Analítica del aprendizaje",
      "Minería de procesos",
      "Análisis de redes de transición",
      "IA explicable",
      "Minería de datos educativos",
      "Software de investigación abierto",
    ],
  },
  gallery: {
    description:
      "Galería de fotos profesionales y de investigación de Manuel J. Gomez, con congresos, entrevistas y colaboraciones con el MIT y la Universidad de Murcia.",
    keywords: [
      "Galería",
      "MIT",
      "Universidad de Murcia",
      "Investigación",
      "Eventos",
      "Fotos",
    ],
  },
  phd: {
    description:
      "Tesis doctoral de Manuel J. Gomez titulada «Hacia la interoperabilidad y nuevos enfoques metodológicos para la evaluación escalable basada en juegos».",
    keywords: [
      "Tesis doctoral",
      "Evaluación basada en juegos",
      "Interoperabilidad",
      "Ontología",
      "IA explicable",
      "Juegos serios",
    ],
  },
  contact: {
    description:
      "Información de contacto del Dr. Manuel J. Gomez: correo electrónico, redes sociales y ubicación de su despacho en la Universidad de Murcia.",
    keywords: [
      "Contacto",
      "Correo electrónico",
      "LinkedIn",
      "Universidad de Murcia",
      "Manuel Gomez",
    ],
  },
};

export const getSEO = (lang, page) => {
  const entry = SEO.find((item) => item.page === page);
  return lang === "es" && SEO_ES[page] ? { ...entry, ...SEO_ES[page] } : entry;
};

export default SEO;
